import React from 'react';
import { TabSong } from '../../types/index.js';
import { useAuthStore } from '../../stores/authStore.js';

/** FRE-128: shows the admin's reject reason, only to the signed-in (non-guest) uploader of the tab. */
export const RejectReasonNote: React.FC<{
  tab: Pick<TabSong, 'id' | 'status' | 'rejectReason' | 'uploaderId'>;
}> = ({ tab }) => {
  const userId = useAuthStore((s) => (s.isGuest ? undefined : s.user?.id));
  if (
    tab.status !== 'REJECTED' ||
    typeof tab.rejectReason !== 'string' ||
    tab.rejectReason.length === 0 ||
    !userId ||
    tab.uploaderId !== userId
  ) {
    return null;
  }
  return (
    <p
      data-testid={`tab-reject-reason-${tab.id}`}
      dir="auto"
      className="m-0 text-xs text-error-soft whitespace-pre-line break-words"
    >
      دلیل رد: {tab.rejectReason}
    </p>
  );
};

RejectReasonNote.displayName = 'RejectReasonNote';
